import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleKindRepositoryBase } from '@skylab-shared/business';
export { SaleKindRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SaleKindRepositoryBase)
export class SaleKindRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
